export const ChatContextApiPath = {
  GET_CHAT_CONTEXT: '/api/v1/chat-context' // GET Get Chat Context
}

export type ChatContextApiPath = (typeof ChatContextApiPath)[keyof typeof ChatContextApiPath]

export interface GetChatContextVars {
  query: string
  brand_id?: string | null
  distribution_code?: string | null
  limit?: number
}

export interface ChatContextItem {
  type: string
  text: string | null
  title?: string | null
  author: string | null
  rating: number | null
  score?: number | null
  media_url?: string | null
  product_id: string | null
}

export interface GetChatContextResponse {
  query: string
  results: ChatContextItem[]
  total: number
}
